import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import { translate as t } from '../../lib/I18n';
import { AccountPages } from '../../constants/AppConstants';

import Link from '../general/Link';


function SmartcardReplacementWarning () {
    return (
        <div className="margin-top padding-bottom">
            <div className="clearfix margin-top">
                <h2 className="text-lg text-weight--normal no-margin padding-bottom--sm alert-warning">
                    { t('account.heading.smartcard.replacement.warning') }
                </h2>

                <div className="box box--padded box--rounded box--warning">
                    <Row>
                        <Col sm={ 12 } md={ 12 } lg={ 10 }>
                            <p className="alert-warning">
                                { t('account.smartcard.text.replacement.warning') }
                            </p>

                             <p className="no-margin">
                                <Link to={ AccountPages.SMARTCARD_REPLACEMENT } >
                                    { t('account.smartcard.text.replacement.linkText') }
                                </Link>
                            </p>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default SmartcardReplacementWarning;



// WEBPACK FOOTER //
// ./src/components/smartcard/SmartcardReplacementWarning.js